/* eslint-disable */
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box, Button, CircularProgress } from "@mui/material";
import RequiredDocument from "../components/PreScreening/RequiredDocument";
import ModalPreScreening from "../components/PreScreening/Modal/ModalPreScreening";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import {
  AdditionalInfoFormAPI,
  SaleForceUploadFile,
  SharePointFolder,
} from "../services/apigateway";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
      style={{
        color: completed || active ? "#fff" : "black",
        backgroundColor: "white",
        border: "1px solid #b5b5b5",
      }}
    >
      {completed ? <CheckIcon /> : <>{props.icon}</>}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const steps = ["Required Document"];

export const hasSelectedFile = (file) => {
  return !!file && typeof file === "object" && typeof file.name === "string";
};

export default function PreScreeningScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const sharePointFoldersReadyRef = React.useRef(false);
  const submitRequiredDocumentInFlightRef = React.useRef(false);
  const submitRequiredDocumentDoneRef = React.useRef(false);

  const [activeStep, setActiveStep] = React.useState(0);
  const [openModal, setOpenModal] = React.useState(false);
  const [showTableFirstYear, setShowTableFirstYear] = React.useState(false);
  const [showTableSecondYear, setShowTableSecondYear] = React.useState(false);
  const [showTableThirdYear, setShowTableThirdYear] = React.useState(false);
  const [showTableCOI, setShowTableCOI] = React.useState(false);
  const [showTableMOA, setShowTableMOA] = React.useState(false);
  const [showTableVAT, setShowTableVAT] = React.useState(false);
  const [showTableShareholder, setShowTableShareholder] = React.useState(false);
  const [showTableMoE, setShowTableMoE] = React.useState(false);
  const [showTableOther, setShowTableOther] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [registrationNumber, setRegistrationNumber] = React.useState("");
  const [objAdditionalForm, setObjAdditionalForm] = React.useState({});
  const [selectedOther, setSelectedOther] = React.useState([]);
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);

  React.useEffect(() => {
    sharePointFoldersReadyRef.current = false;
    submitRequiredDocumentInFlightRef.current = false;
    submitRequiredDocumentDoneRef.current = false;

    const element = document.querySelector(".MuiStepLabel-iconContainer");
    if (element) {
      const elementText = document.querySelector(".css-1am1g1a");
      if (elementText) {
        elementText.textContent = "3";
      }
    }
    // Call your RequestForm function here
    const fetchData = async () => {
      try {
        setLoading(true);
        const additionalInfo = await AdditionalInfoFormAPI.getRequestForm(id);
        setObjAdditionalForm(additionalInfo);

        // const userInfo = helper.Auth.getTokenData()
        if (additionalInfo.CustomerId) {
          // const result = await SharePointFolder.createMultipleFoldersByAccount({
          //   accountId: additionalInfo.CustomerId,
          // });
          // if (result.status === "success") {
          const response = await SharePointFolder.getPathByAccount(
            additionalInfo.CustomerId
          );
          const filesSharePoint = response.responseData;

          const fin = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Financial"
          );
          const coi = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_COI"
          );
          const moa = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_MOA"
          );
          const shr = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_List_Sharehold"
          );
          const vat = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_VAT_Reg"
          );
          const moe = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Reg_by_MoE"
          );
          const oth = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Others"
          );

          setPathsSharePoint({
            Account_Common_CTR_Financial: fin.Path || "",
            Account_Common_CTR_COI: coi.Path || "",
            Account_Common_CTR_MOA: moa.Path || "",
            Account_Common_CTR_List_Sharehold: shr.Path || "",
            Account_Common_CTR_VAT_Reg: vat.Path || "",
            Account_Common_CTR_Reg_by_MoE: moe.Path || "",
            Account_Common_CTR_Others: oth.Path || "",
          });
          // } else {
          //   console.error("Error create folders:", result);
          // }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const isUploadFailedResponse = (uploadResponse) => {
    return (
      !uploadResponse ||
      uploadResponse.error ||
      uploadResponse.error_description ||
      uploadResponse.message === "error" ||
      uploadResponse.message === "Upload failed" ||
      uploadResponse.messagetype === "Fail" ||
      uploadResponse.messagetype === "fail"
    );
  };

  const showUploadFailedAlert = (message) => {
    return Swal.fire({
      title: "Upload Failed",
      text:
        message ||
        "Upload failed. Please try again or contact your administrator.",
      icon: "error",
      position: "center",
    });
  };

  const ensureSharePointFoldersReady = async () => {
    if (sharePointFoldersReadyRef.current) {
      return true;
    }

    if (!objAdditionalForm.CustomerId) {
      await Swal.fire({
        title: "Upload Failed",
        text: "Customer ID is missing, so SharePoint folders cannot be prepared.",
        icon: "error",
        position: "center",
      });
      return false;
    }

    try {
      const result = await SharePointFolder.createMultipleFoldersByAccount({
        accountId: objAdditionalForm.CustomerId,
      });

      if (result?.status === "success") {
        sharePointFoldersReadyRef.current = true;
        return true;
      }

      await Swal.fire({
        title: "Folder Preparation Failed",
        text:
          result?.message ||
          "Unable to prepare SharePoint folders before upload.",
        icon: "error",
        position: "center",
      });
      return false;
    } catch (error) {
      console.error("Error while preparing SharePoint folders:", error);
      await Swal.fire({
        title: "Folder Preparation Failed",
        text:
          error?.message ||
          "Unable to prepare SharePoint folders before upload.",
        icon: "error",
        position: "center",
      });
      return false;
    }
  };

  const uploadFileToSaleForceAttachment = async (file) => {
    try {
      if (!hasSelectedFile(file)) {
        return true;
      }

      let CustomerId = objAdditionalForm.CustomerId;
      const uploadResponse = await SaleForceUploadFile.uploadFile(CustomerId, [
        file,
      ]);
      console.log("Upload response:", uploadResponse);

      if (isUploadFailedResponse(uploadResponse)) {
        await showUploadFailedAlert(
          uploadResponse?.message || uploadResponse?.error_description
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }

      await showUploadFailedAlert(error?.message);
      return false;
    }
  };

  const createSharePointUploader = (pathKey) => async (file) => {
    try {
      if (!hasSelectedFile(file)) {
        return true;
      }

      const namefolder = pathsSharePoint[pathKey];
      const uploadResponse = await SharePointFolder.uploadFile(namefolder, [
        file,
      ]);
      console.log("Upload response:", uploadResponse);

      if (isUploadFailedResponse(uploadResponse)) {
        await showUploadFailedAlert(
          uploadResponse?.message || uploadResponse?.error_description
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }

      await showUploadFailedAlert(error?.message);
      return false;
    }
  };

  const uploadFileToFinancial = createSharePointUploader(
    "Account_Common_CTR_Financial"
  );
  const uploadFileToCOI = createSharePointUploader("Account_Common_CTR_COI");
  const uploadFileToMOA = createSharePointUploader("Account_Common_CTR_MOA");
  const uploadFileToVAT = createSharePointUploader(
    "Account_Common_CTR_VAT_Reg"
  );
  const uploadFileToShareholders = createSharePointUploader(
    "Account_Common_CTR_List_Sharehold"
  );
  const uploadToFileToMoE = createSharePointUploader(
    "Account_Common_CTR_Reg_by_MoE"
  );
  const uploadToFileToOther = createSharePointUploader(
    "Account_Common_CTR_Others"
  );

  const uploadOrThrow = async (uploadFn, file) => {
    const uploadResult = await uploadFn(file);
    if (uploadResult === false) {
      throw new Error("Upload failed");
    }
  };

  const createSalesforceAttachmentFile = (file, prefix) => {
    if (!hasSelectedFile(file)) {
      return null;
    }

    const fileExtension = file.name.split(".").pop();
    return new File([file], `${prefix}.${fileExtension}`, {
      type: file.type,
    });
  };

  const getUploadInputs = () => {
    const FinancialFirst = document.getElementById("FinancialFirst");
    const FinancialSecond = document.getElementById("FinancialSecond");
    const FinancialThird = document.getElementById("FinancialThird");
    const FileCOI = document.getElementById("FileCOI");
    const FileMOA = document.getElementById("FileMOA");
    const FileVAT = document.getElementById("FileVAT");
    const FileShareholder = document.getElementById("FileShareholder");
    const FileMoE = document.getElementById("FileMoE");
    const FileOther = document.getElementById("FileOther2");

    return {
      FinancialFirst,
      FinancialSecond,
      FinancialThird,
      FileCOI,
      FileMOA,
      FileVAT,
      FileShareholder,
      FileMoE,
      FileOther,
      selectedFilesFirst: FinancialFirst.files[0],
      selectedFilesSecond: FinancialSecond.files[0],
      selectedFilesThird: FinancialThird.files[0],
      selectedFilesCOI: FileCOI.files[0],
      selectedFilesMOA: FileMOA.files[0],
      selectedFilesVAT: FileVAT.files[0],
      selectedFileShareholder: FileShareholder.files[0],
      selectedFileMoE: FileMoE ? FileMoE.files[0] : null,
      selectedFileOther: FileOther.files,
    };
  };

  const resetUploadInputsAndTables = (uploadInputs) => {
    uploadInputs.FinancialFirst.value = "";
    uploadInputs.FinancialSecond.value = "";
    uploadInputs.FinancialThird.value = "";
    uploadInputs.FileCOI.value = "";
    uploadInputs.FileMOA.value = "";
    uploadInputs.FileVAT.value = "";
    uploadInputs.FileShareholder.value = "";
    if (uploadInputs.FileMoE) {
      uploadInputs.FileMoE.value = "";
    }
    uploadInputs.FileOther.value = "";

    setShowTableFirstYear(false);
    setShowTableSecondYear(false);
    setShowTableThirdYear(false);
    setShowTableCOI(false);
    setShowTableMOA(false);
    setShowTableVAT(false);
    setShowTableShareholder(false);
    setShowTableMoE(false);
    setShowTableOther(false);
  };

  const runDocumentUploads = async () => {
    const foldersReady = await ensureSharePointFoldersReady();
    if (!foldersReady) {
      return false;
    }

    const uploadInputs = getUploadInputs();

    const sharePointUploads = [
      [uploadFileToFinancial, uploadInputs.selectedFilesFirst],
      [uploadFileToFinancial, uploadInputs.selectedFilesSecond],
      [uploadFileToFinancial, uploadInputs.selectedFilesThird],
      [uploadFileToCOI, uploadInputs.selectedFilesCOI],
      [uploadFileToMOA, uploadInputs.selectedFilesMOA],
      [uploadFileToShareholders, uploadInputs.selectedFileShareholder],
      [uploadFileToVAT, uploadInputs.selectedFilesVAT],
      [uploadToFileToMoE, uploadInputs.selectedFileMoE],
    ];

    const salesforceAttachments = [
      createSalesforceAttachmentFile(uploadInputs.selectedFilesFirst, "FS1"),
      createSalesforceAttachmentFile(uploadInputs.selectedFilesSecond, "FS2"),
      createSalesforceAttachmentFile(uploadInputs.selectedFilesThird, "FS3"),
      createSalesforceAttachmentFile(uploadInputs.selectedFilesCOI, "COI"),
      createSalesforceAttachmentFile(uploadInputs.selectedFilesMOA, "MOA"),
      createSalesforceAttachmentFile(uploadInputs.selectedFilesVAT, "VAT"),
      createSalesforceAttachmentFile(uploadInputs.selectedFileMoE, "MOE"),
    ];

    try {
      for (const [uploadFn, file] of sharePointUploads) {
        await uploadOrThrow(uploadFn, file);
      }

      for (const file of uploadInputs.selectedFileOther) {
        await uploadOrThrow(uploadToFileToOther, file);
      }

      for (const attachment of salesforceAttachments) {
        await uploadOrThrow(uploadFileToSaleForceAttachment, attachment);
      }

      resetUploadInputsAndTables(uploadInputs);
      return true;
    } catch (error) {
      console.error("Error in handling file upload:", error);
      return false;
    }
  };

  const uploadFiles = async () => {
    return runDocumentUploads();
  };

  const updateFiles = async () => {
    return runDocumentUploads();
  };

  const hasRequiredUploadDocuments = () => {
    return (
      objAdditionalForm.Documents?.FinancialStatement.FirstYear.Filename &&
      objAdditionalForm.Documents?.CertificateOfIncorporation.Filename &&
      objAdditionalForm.Documents?.MemorandumOfAssociation.Filename &&
      objAdditionalForm.Documents?.ListOfShareholders.Filename
    );
  };

  const confirmAndRunUpload = async ({
    title,
    confirmButtonText,
    denyButtonText,
    setLoadingBeforePrompt = false,
    runUpload,
    onSuccess,
  }) => {
    if (setLoadingBeforePrompt) {
      setLoading(true);
    }

    const result = await Swal.fire({
      title,
      icon: "question",
      position: "center",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText,
      denyButtonText,
      cancelButtonColor: "red",
    });

    if (!result.isConfirmed) {
      if (setLoadingBeforePrompt) {
        setLoading(false);
      }
      return false;
    }

    if (!setLoadingBeforePrompt) {
      setLoading(true);
    }

    try {
      const uploadSucceeded = await runUpload();

      if (uploadSucceeded) {
        await onSuccess?.();
        return true;
      }

      return false;
    } finally {
      setLoading(false);
    }
  };

  const renderFormPreScreening = (page) => {
    switch (page) {
      case 0:
        return (
          <RequiredDocument
            formData={(data) => submitRequiredDocument(data)}
            formDataDraft={(data) => updateRequiredDocument(data)}
            formId={id}
            showTableFirstYear={showTableFirstYear}
            setShowTableFirstYear={setShowTableFirstYear}
            showTableSecondYear={showTableSecondYear}
            setShowTableSecondYear={setShowTableSecondYear}
            showTableThirdYear={showTableThirdYear}
            setShowTableThirdYear={setShowTableThirdYear}
            showTableCOI={showTableCOI}
            setShowTableCOI={setShowTableCOI}
            showTableMOA={showTableMOA}
            setShowTableMOA={setShowTableMOA}
            showTableVAT={showTableVAT}
            setShowTableVAT={setShowTableVAT}
            showTableShareholder={showTableShareholder}
            setShowTableShareholder={setShowTableShareholder}
            showTableMoE={showTableMoE}
            setShowTableMoE={setShowTableMoE}
            showTableOther={showTableOther}
            setShowTableOther={setShowTableOther}
            setObjAdditionalForm={setObjAdditionalForm}
            objAdditionalForm={objAdditionalForm}
            setSelectedOther={setSelectedOther}
            selectedOther={selectedOther}
          />
        );
      default:
        return <></>;
    }
  };

  const updateRequestFormByIds = async (data, nextStep) => {
    let dataUpdate = data;
    console.log(dataUpdate);
    Swal.fire({
      title: "Do you want to save form?",
      icon: "question",
      position: "center",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      cancelButtonColor: "red",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const res = await AdditionalInfoFormAPI.updateRequestForm(dataUpdate);
        console.log("updateRequestForm :: ", res);
        setLoading(false);
        if (res.error_description) {
          Swal.fire({
            title: res.error_description,
            icon: "error",
            // showConfirmButton: false,
            // timer: 1200,
          });
        } else {
          Swal.fire({
            title: "Saved!",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
      setLoading(false);
    });
    document.getElementById("check-form-data-register-save-draft").click();
  };

  const updateRequestFormByIdAndNextStep = async (data) => {
    let dataUpdate = data;
    Swal.fire({
      title: "Do you want to submit form?",
      icon: "question",
      position: "center",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      cancelButtonColor: "red",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const res = await AdditionalInfoFormAPI.updateRequestForm(dataUpdate);
        console.log("updateRequestForm :: ", res);
        setLoading(false);
        if (res.error_description) {
          Swal.fire({
            title: res.error_description,
            icon: "error",
            // showConfirmButton: false,
            // timer: 1200,
          });
        } else {
          setActiveStep(activeStep + 1);
          Swal.fire({
            title: "Saved!",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
      setLoading(false);
    });
    document.getElementById("check-form-data-register-save-draft-next").click();
  };

  const submitRequestFormByIds = async (data) => {
    let dataFinal = data;
    if (dataFinal) {
      Swal.fire({
        title: "Do you want to submit form?",
        icon: "question",
        position: "center",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        cancelButtonColor: "red",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const res = await AdditionalInfoFormAPI.submitRequestForm(dataFinal);
          console.log("submitRequestForm :: ", res);
          setLoading(false);
          if (res) {
            if (res.error_description) {
              Swal.fire({
                title: res.error_description,
                icon: "error",
                // showConfirmButton: false,
                // timer: 1200,
              });
            } else {
              // setRequestId(res.RequestFormHeaderId);
              setRegistrationNumber(res.RegistrationNumber);
              // setOpenModal(true);
              setActiveStep(activeStep + 1);
            }
          }
        }
        setLoading(false);
      });
    }
    document.getElementById("check-form-data-register").click();
  };

  const submitRequiredDocument = async (data) => {
    if (
      !data ||
      submitRequiredDocumentInFlightRef.current ||
      submitRequiredDocumentDoneRef.current
    ) {
      return;
    }

    submitRequiredDocumentInFlightRef.current = true;

    try {
      setLoading(true);
      const res = await AdditionalInfoFormAPI.submitRequestForm(data);
      console.log("submitRequiredDocument :: ", res);

      if (res?.error_description) {
        await Swal.fire({
          title: res.error_description,
          icon: "error",
        });
        return;
      }

      if (res) {
        setRegistrationNumber(res.RegistrationNumber);
        setOpenModal(true);
        submitRequiredDocumentDoneRef.current = true;
      }
    } finally {
      setLoading(false);
      submitRequiredDocumentInFlightRef.current = false;
    }
  };

  const handleUploadFiles = async function (e) {
    try {
      const allFilesExist = await checkFilesExist();
      if (!allFilesExist) {
        return;
      }

      // Check if any files are selected for upload
      if (hasRequiredUploadDocuments()) {
        // If files are selected, initiate the file upload process and handle submission
        await confirmAndRunUpload({
          title: "Do you want to submit form?",
          confirmButtonText: "Yes",
          denyButtonText: "No",
          runUpload: uploadFiles,
          onSuccess: async () => {
            document.getElementById("check-form-data-register").click();
          },
        });
      } else {
        Swal.fire({
          title: "Please attach required documents",
          icon: "error",
          position: "center",
        });
      }
    } catch (error) {
      console.error("Error in handling form submission:", error);
    }
  };

  let formUpdateFiles = false;
  const updateRequiredDocument = async (data) => {
    //setLoading(true);
    let dataUpdate = data;

    if (dataUpdate && !formUpdateFiles) {
      const res = await AdditionalInfoFormAPI.updateRequestForm(dataUpdate);
      if (res) {
        console.log("updateRequiredDocument :: ", res);
        setLoading(false);
        //setOpenModal(true);
        formUpdateFiles = true; // Set the flag to true after successful submission
      }
      //setLoading(false);
    }

    if (!formUpdateFiles) {
      document.getElementById("check-form-data-register-save-draft").click();
    }
  };

  const checkSizeFilesValidate = () => {
    let maxSize = 20;
    let mbConvert = 1048576;
    let arrayFileBuffer = [];
    const FinancialFirst = document.getElementById("FinancialFirst").files;
    const FinancialSecond = document.getElementById("FinancialSecond").files;
    const FinancialThird = document.getElementById("FinancialThird").files;
    const fileSelectedCOI = document.getElementById("FileCOI").files;
    const fileSelectedMOA = document.getElementById("FileMOA").files;
    const fileSelectedVAT = document.getElementById("FileVAT").files;
    const fileSelectedShareholders =
      document.getElementById("FileShareholder").files;
    const fileInputRefMoE = document.getElementById("FileMoE").files;
    const attachmentsOther1 = document.getElementById("FileOther1").files;
    const attachmentsOther2 = document.getElementById("FileOther2").files;

    // check all files upload
    for (let i = 0; i < FinancialFirst.length; i++) {
      arrayFileBuffer.push(FinancialFirst[i]);
    }
    for (let i = 0; i < FinancialSecond.length; i++) {
      arrayFileBuffer.push(FinancialSecond[i]);
    }
    for (let i = 0; i < FinancialThird.length; i++) {
      arrayFileBuffer.push(FinancialThird[i]);
    }
    for (let i = 0; i < fileSelectedCOI.length; i++) {
      arrayFileBuffer.push(fileSelectedCOI[i]);
    }
    for (let i = 0; i < fileSelectedMOA.length; i++) {
      arrayFileBuffer.push(fileSelectedMOA[i]);
    }
    for (let i = 0; i < fileSelectedVAT.length; i++) {
      arrayFileBuffer.push(fileSelectedVAT[i]);
    }
    for (let i = 0; i < fileSelectedShareholders.length; i++) {
      arrayFileBuffer.push(fileSelectedShareholders[i]);
    }
    for (let i = 0; i < fileInputRefMoE.length; i++) {
      arrayFileBuffer.push(fileInputRefMoE[i]);
    }
    for (let i = 0; i < attachmentsOther1.length; i++) {
      arrayFileBuffer.push(attachmentsOther1[i]);
    }
    for (let i = 0; i < attachmentsOther2.length; i++) {
      arrayFileBuffer.push(attachmentsOther2[i]);
    }

    let sizeAllFiles = 0;
    arrayFileBuffer.forEach((item) => {
      sizeAllFiles += item.size;
    });

    return sizeAllFiles / mbConvert > maxSize;
  };

  const checkFilesExist = async () => {
    const FinancialFirst = document.getElementById("FinancialFirst");
    const FinancialSecond = document.getElementById("FinancialSecond");
    const FinancialThird = document.getElementById("FinancialThird");
    const FileCOI = document.getElementById("FileCOI");
    const FileMOA = document.getElementById("FileMOA");
    const FileVAT = document.getElementById("FileVAT");
    const FileShareholder = document.getElementById("FileShareholder");
    const FileMoE = document.getElementById("FileMoE");
    const FileOther = document.getElementById("FileOther2");

    // console.log('FinancialFirst >> ', FinancialFirst);
    //   console.log('FinancialSecond >> ', FinancialSecond);
    //   console.log('FinancialThird >> ', FinancialThird);
    //   console.log('FileCOI >> ', FileCOI);
    //   console.log('FileMOA >> ', FileMOA);
    //   console.log('FileVAT >> ', FileVAT);
    //   console.log('FileShareholder >> ', FileShareholder);
    //   console.log('FileMoE >> ', FileMoE);
    //   console.log('FileOther >> ', FileOther);

    let isFinancialFirstExists = true;
    let isFinancialSecondExists = true;
    let isFinancialThirdExists = true;
    let isFileCOIExists = true;
    let isFileMOAExists = true;
    // let isFileVATExists = true;
    let isFileShareholderExists = true;
    let isFileMoEExists = true;
    let isFileOtherExists = true;

    const filesNotExist = [];
    if (FinancialFirst.files.length > 0) {
      isFinancialFirstExists = await isFileExists(FinancialFirst.files[0]);
      if (!isFinancialFirstExists) {
        filesNotExist.push(FinancialFirst.files[0].name);
      }
    }
    if (FinancialSecond.files.length > 0) {
      isFinancialSecondExists = await isFileExists(FinancialSecond.files[0]);
      if (!isFinancialSecondExists) {
        filesNotExist.push(FinancialSecond.files[0].name);
      }
    }
    if (FinancialThird.files.length > 0) {
      isFinancialThirdExists = await isFileExists(FinancialThird.files[0]);
      if (!isFinancialThirdExists) {
        filesNotExist.push(FinancialThird.files[0].name);
      }
    }
    if (FileCOI.files.length > 0) {
      isFileCOIExists = await isFileExists(FileCOI.files[0]);
      if (!isFileCOIExists) {
        filesNotExist.push(FileCOI.files[0].name);
      }
    }
    if (FileMOA.files.length > 0) {
      isFileMOAExists = await isFileExists(FileMOA.files[0]);
      if (!isFileMOAExists) {
        filesNotExist.push(FileMOA.files[0].name);
      }
    }
    if (FileVAT.files.length > 0) {
      // isFileVATExists = await isFileExists(FileVAT.files[0]);
      // if (!isFileVATExists) {
      //   filesNotExist.push(FileVAT.files[0].name);
      // }
    }
    if (FileShareholder.files.length > 0) {
      isFileShareholderExists = await isFileExists(FileShareholder.files[0]);
      if (!isFileShareholderExists) {
        filesNotExist.push(FileShareholder.files[0].name);
      }
    }
    if (FileMoE) {
      if (FileMoE.files.length > 0) {
        isFileMoEExists = await isFileExists(FileMoE.files[0]);
        if (!isFileMoEExists) {
          filesNotExist.push(FileMoE.files[0].name);
        }
      }
    }

    if (FileOther.files.length > 0) {
      for (let i = 0; i < FileOther.files.length; i++) {
        isFileOtherExists &= await isFileExists(FileOther.files[i]);
        if (!isFileOtherExists) {
          filesNotExist.push(FileOther.files[i].name);
        }
      }
    }

    if (filesNotExist.length > 0) {
      Swal.fire({
        title: "Warning",
        text: "Files are not exists: " + filesNotExist.join(", "),
        icon: "warning",
        position: "center",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    }

    return !(filesNotExist.length > 0);
  };

  const isFileExists = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("abort", function (event) {
        resolve(false);
      });
      reader.addEventListener("error", function (event) {
        resolve(false);
      });
      reader.addEventListener("loadend", function (event) {
        resolve(true);
      });
      reader.readAsDataURL(file);
    });
  };

  const handleUpdateFiles = async function (e) {
    try {
      const allFilesExist = await checkFilesExist();
      if (!allFilesExist) {
        return;
      }

      // If files are selected, initiate the file upload process and handle submission
      await confirmAndRunUpload({
        title: "Do you want to save draft form?",
        confirmButtonText: "Save",
        denyButtonText: "Cancel",
        setLoadingBeforePrompt: true,
        runUpload: updateFiles,
        onSuccess: async () => {
          document
            .getElementById("check-form-data-register-save-draft")
            .click();
          setSelectedOther([]);
          await Swal.fire({
            title: "Saved!",
            icon: "success",
            showConfirmButton: false,
            timer: 1200,
          });
        },
      });
      // }
    } catch (error) {
      console.error("Error in handling form submission:", error);
    }
    // }
  };

  return (
    <>
      <Stack sx={{ width: "100%", margin: 5 }} spacing={4}>
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {/* button */}
        <Box>{renderFormPreScreening(activeStep)}</Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {loading && (
            <Backdrop sx={{ color: "#fff", zIndex: 2 }} open={true}>
              <span
                style={{
                  justifyContent: "center",
                  position: "fixed",
                  top: "40%",
                }}
              >
                <Box
                  sx={{ p: 2, m: 2, justifyContent: "center", display: "flex" }}
                >
                  <CircularProgress
                    style={{
                      width: 100,
                      height: 100,
                      color: "rgba(184,0,200,1)",
                    }}
                  />
                </Box>
                <Box sx={{ justifyContent: "center", display: "flex" }}>
                  <label style={{ fontSize: 22, fontWeight: "bold" }}>
                    {" "}
                    Please wait...
                  </label>
                </Box>
              </span>
            </Backdrop>
          )}
          <Button
            sx={{ p: 1, m: 1 }}
            variant="outlined"
            color="error"
            //onClick={() => setActiveStep(activeStep > 0 ? activeStep - 1 : 0)}
            onClick={() => {
              Swal.fire({
                title: "Do you want to leave this page?",
                icon: "question",
                position: "center",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/main");
                }
              });
            }}
          >
            Cancel
          </Button>
          {activeStep >= 0 ? (
            <Button
              sx={{ p: 1, m: 1 }}
              variant="outlined"
              disabled={loading}
              //onClick={() => updateRequestFormByIds()}
              onClick={() => {
                handleUpdateFiles();
              }}
            >
              Save
            </Button>
          ) : null}
          <Button
            sx={{ p: 1, m: 1 }}
            variant="contained"
            disabled={loading}
            onClick={() => {
              if (activeStep === 0) {
                // updateRequestFormByIdAndNextStep();
                handleUploadFiles();
                // setActiveStep(activeStep + 1); // Move to the next step
              } else if (activeStep === 1) {
                handleUploadFiles();
              } else {
                setActiveStep(activeStep + 1); // Move to the next step
              }
            }}
            // onClick={() => {
            //   if (activeStep > steps.length - 2) {
            //     submitRequestFormByIds();
            //     handleSubmit();
            //     //setActiveStep(activeStep + 1);
            //   } else {
            //     setActiveStep(activeStep + 1);
            //   }
            // }}
            type="submit"
          >
            {activeStep < 0 ? "Next" : "Submit"}
          </Button>
        </Box>
      </Stack>
      <ModalPreScreening
        request={registrationNumber}
        open={openModal}
        onHide={() => setOpenModal(false)}
        style={{ zIndex: 9999 }}
      />
    </>
  );
}
